import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useCallback, useState } from "react";

import BuyQtySheet from "./BuyQtySheet";
import BuyQtyAnalytics from "./BuyQtyAnalytics/BuyQtyAnalytics";

/**
 * Analytics above the buy qty table. More Filters (table FilterModal) scopes both the table
 * and analytics — same pattern as MRP.
 */
const BuyQtySheetShell = () => {
	const [view] = useState("table");
	const [scope, setScope] = useState({ filter: {}, search: "" });
	const [filterUi, setFilterUi] = useState({ open: () => {}, count: 0 });
	const onFilterUiChange = useCallback((api) => {
		setFilterUi(api || { open: () => {}, count: 0 });
	}, []);

	return (
		<Stack spacing={1.5} sx={{ width: "100%" }}>
			{view === "table" ? (
				<>
					<BuyQtyAnalytics
						filter={scope.filter}
						search={scope.search}
						onMoreFilters={filterUi.open}
						activeFilterCount={filterUi.count}
					/>
					<Box sx={{ width: "100%" }}>
						<BuyQtySheet onFilterChange={setScope} onFilterUiChange={onFilterUiChange} />
					</Box>
				</>
			) : null}
		</Stack>
	);
};

export default BuyQtySheetShell;
